import React from "react";
import { Row, Col, Button } from 'react-bootstrap';
import Sidebar from "../../../../components/profile/Sidebar";
import Header from "../../../../components/profile/Header";
import { BrowserView, MobileView } from "react-device-detect";
import { LAYOUTS } from "../../../../constants";
import { BoldText } from "../../../../components/texts/PageText";
import { FaChevronCircleRight } from "react-icons/fa";
import MobileSidebar from "../../../../components/profile/MobileSidebar";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { Link } from "react-router-dom";

const SiteNotification = (props) => {

  const BodySection = () => {
    return (
      <div>
        <Row className="TFList">
          <Col xs={8}>
            <h5>
              <BoldText>Get bot link</BoldText>
            </h5>
            <p> Please do not share this link with anyone </p>
          </Col>
          <Col xs={4} className="text-right">
            <span style={{ color: "#a6c" }} className="icon-fa">
              <FaChevronCircleRight />
            </span>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div>
      <BrowserView>
        <div className="container" style={LAYOUTS.profileHeaderStyle}>
          <Row>
            <Header />
          </Row>
        </div>
        <div className="container pb-4" style={LAYOUTS.bodyStyle}>
          <Row>
            <Col md={3}>
              <Sidebar />
            </Col>
            <Col md={9} className="text-left">
              <span style={styles.profileComponentHeader}>Telegram Bot</span>
              <hr style={styles.hr} />
              <BodySection />

              <Link to={"/settings/notification"}>
                <Button
                  variant="secondary"
                  size="md"
                  style={{ float: "right" }}
                >
                  <span style={{ float: "left" }}>
                    <FaArrowAltCircleLeft size={17} />
                  </span>
                  <span style={styles.notificationBackbutton}>Back</span>
                </Button>
              </Link>
            </Col>
          </Row>
        </div>
      </BrowserView>
      <MobileView>
        <div className="container header" style={LAYOUTS.profileHeaderStyle}>
          <Row>
            {" "}
            <Header />{" "}
          </Row>
        </div>
        <div className="container pb-4 headerBody" style={LAYOUTS.bodyStyle}>
          <Row>
            <MobileSidebar />
            <span style={styles.profileComponentHeader}>Telegram Bot</span>
            <Col xs={12} className="text-left mt-2">
              <BodySection />

              <Link to={"/settings/notification"}>
                <Button
                  variant="secondary"
                  size="md"
                  style={{ float: "right" }}
                >
                  <span style={{ float: "left" }}>
                    <FaArrowAltCircleLeft size={17} />
                  </span>
                  <span style={styles.notificationBackbutton}>Back</span>
                </Button>
              </Link>
            </Col>
          </Row>
        </div>
      </MobileView>
    </div>
  );
};

const styles = {
  headerStyle: {
    paddingLeft: 25,
    height: 300,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  profileComponentHeader: {
    fontSize: "25px",
    fontWeight: 600,
  },
  notificationBackbutton: {
    paddingLeft: "10px",
    fontWeight: "600",
    fontSize: "small",
  },
};

export default SiteNotification;
